module.exports = __webpack_public_path__ + "img/yoga_demo-400x300.44b4f932.jpg";